import React from "react";
import { CaretRight } from "@phosphor-icons/react";

const STAGES = [
  { id: "rwi", label: "Scenario", sub: "Operating context" },
  { id: "request", label: "Request", sub: "Triggered AI work" },
  { id: "bloom", label: "Routing", sub: "Cost · Quality · Latency · Risk" },
  { id: "katlas", label: "KATLAS", sub: "Authority · Approval · Disclosure" },
  { id: "outcome", label: "Outcome", sub: "Action · Receipt · Audit" },
];

export const Pipeline = ({ activeStage }) => {
  return (
    <div className="px-6 py-2.5 border-b border-stone-200 bg-white flex items-center gap-2 overflow-x-auto scroll-soft">
      {STAGES.map((s, i) => {
        const active = activeStage === s.id;
        const ahead = STAGES.findIndex((x) => x.id === activeStage) > i;
        return (
          <React.Fragment key={s.id}>
            <div
              className={`flex items-center gap-2 px-2 py-1 rounded-sm ${
                active ? "bg-stone-900 text-white" : ahead ? "text-stone-700" : "text-stone-400"
              }`}
            >
              <span
                className={`font-mono text-[10px] ${
                  active ? "text-white/70" : "text-stone-400"
                }`}
              >
                0{i + 1}
              </span>
              <div className="flex flex-col leading-tight">
                <span className="text-[11px] font-medium">{s.label}</span>
                <span className={`text-[10px] ${active ? "text-white/70" : "text-stone-400"}`}>
                  {s.sub}
                </span>
              </div>
            </div>
            {i < STAGES.length - 1 && <CaretRight size={12} className="text-stone-300 shrink-0" />}
          </React.Fragment>
        );
      })}
      <div className="flex-1" />
      <div className="hidden md:block text-[11px] text-stone-700">
        <span className="font-medium text-stone-900">AI suggests.</span>{" "}
        <span className="font-medium text-stone-900">Authorised roles decide.</span>{" "}
        <span className="font-medium text-stone-900">KATLAS signs the receipt.</span>
      </div>
    </div>
  );
};
